const generateInvoice = ({email, event}) => {
    return new Promise((resolve, reject) => {
        axios.get(`/api/v1/events/${event}/invoices?email=${email}`)
            .then(response => resolve(response))
            .catch(({ response }) => reject(response.data))
            .done();
    });
};

const generateCertificate = ({email, event}) => {
    return new Promise((resolve, reject) => {
        axios.get(`/api/v1/events/${event}/certificates?email=${email}`)
            .then(response => resolve(response))
            .catch(({ response }) => reject(response.data))
            .done();
    });
};


const fetchEvents = type => {
    return new Promise((resolve, reject) => {
        axios.get(`/api/v1/events?type=${type}`)
            .then(({ data }) => resolve(data.events.data))
            .catch(({ response }) => reject(response))
            .done();
    })
};

export default {
    fetchEvents,
    generateInvoice,
    generateCertificate
};